export default {
  labels: {
    in_store_card_payments_not_supported: '⚠️ Apenas dinheiro no restaurante. Pagamento com cartão não aceite.',
  },
};
